import React from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "./../Images/vistaplots-logo.png";
import { FiUsers } from "react-icons/fi";
import { FaRegBuilding } from "react-icons/fa";
import InvestmentList from "./InvestmentList";

const Sidebar = () => {
  return (
    <>
      <div className="sidebar" id="sidebar-wrapper">
        <div className="sidebar-logo mb-2 text-center">
          <Link to="/admin-dashboard">
            <img width="65px" src={logo} alt="" />
          </Link>
        </div>

        <div className="list">
          <ul className="list-group d-flex justify-content-center">

            <NavLink to="/admin-dashboard" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-speedometer2 me-2"></i> Dashboard</NavLink>

            {/* <NavLink to="/add-project" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-list-ol me-2"></i> Add Project</NavLink> */}



            {/* <NavLink to="/add-user" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-list-ol me-2"></i> Add User</NavLink> */}
            


            <NavLink to="/users" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-person-add me-2"></i> Users</NavLink>

            <NavLink to="/projects-list" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-list-ol me-2"></i> Projects</NavLink>

{/* 
            <NavLink to="/property-type" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-list-ol me-2"></i>Properties Type</NavLink> */}
            <NavLink to="/orders" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-list-ol me-2"></i>Orders</NavLink>

            <NavLink to="/investment" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-list-ol me-2"></i>Investment</NavLink>
            <NavLink to="/logout" className="list-item d-flex align-items-center justify-content-start"><i class="bi bi-box-arrow-left me-2"></i> Log Out</NavLink>

          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
